// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Baustelle } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useDeleteBaustelle(): (id: string) => Promise<Baustelle> {
  const getAPI = useGetApi();
  return useCallback(
    async (id) => (await getAPI()).baustellen.deleteBaustelle({ id }),
    [getAPI]
  );
}
